// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileEventRegister_backIcon__iSMa3","regiBtn":"AdminMobileEventRegister_regiBtn__DKMKI"};